export const MIX_AND_MATCH = {
    swapIcon: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 20.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
<style type="text/css">
    .st0{fill:#FFFFFF;}
    .st1{fill:#231F20;}
</style>
<g>
    <circle class="st0" cx="15" cy="15" r="15"/>
    <path class="st1" d="M11.6,8.1c-3.5,0-6.4,3-6.4,6.5c0,0.5,0.4,0.8,0.8,0.8c0.5,0,0.8-0.4,0.8-0.8c0-2.6,2.1-4.7,4.7-4.7h10.1
        l-2.3,2.3c-0.2,0.2-0.5,0.7-0.1,1.1c0.4,0.4,0.8,0.3,1.1,0l0.1-0.1l3.7-3.7c0.3-0.3,0.3-0.8,0-1.1l-3.7-3.7c-0.3-0.3-0.8-0.3-1.1,0
        c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.4,0.3,0.6l2.3,2.3L11.6,8.1L11.6,8.1z"/>
    <path class="st1" d="M9.7,16.4c-0.2,0-0.4,0.1-0.6,0.3l-3.7,3.7c-0.3,0.3-0.3,0.8,0,1.1l3.7,3.7c0.3,0.3,0.8,0.3,1.1,0
        c0.3-0.3,0.3-0.8,0-1.1L8,21.8H18c3.5,0,6.4-2.9,6.4-6.4c0-0.5-0.4-0.8-0.8-0.8s-0.8,0.4-0.8,0.8c0,2.6-2.1,4.7-4.7,4.7H8l2.3-2.3
        c0.3-0.3,0.3-0.8,0-1.1C10.2,16.5,10,16.4,9.7,16.4z"/>
</g>
</svg>`,
    cartIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill="#000" fill-rule="evenodd" d="M8.143 14.22c.74 0 1.34.6 1.34 1.34 0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34zm5.955 0c.74 0 1.34.6 1.34 1.34 0 .74-.6 1.34-1.34 1.34-.74 0-1.34-.6-1.34-1.34 0-.74.6-1.34 1.34-1.34zM5.358 4.1c.302 0 .549.233.57.529l1.316 7.465h8.097l1.025-5.805c.054-.311.35-.52.661-.464.312.055.52.351.464.662l-1.113 6.317-.008.032c-.047.283-.293.499-.59.499H6.806c-.265 0-.49-.172-.569-.41l-.022-.088-1.34-7.594H3.072c-.316 0-.572-.256-.572-.571 0-.316.256-.572.572-.572h2.287zm6.065-.975c.228 0 .417.17.446.39l.005.06v2.7h2.699c.248 0 .45.2.45.45 0 .22-.159.404-.37.442l-.08.007h-2.7v2.7l-.007.08c-.038.21-.221.37-.443.37-.227 0-.416-.17-.445-.389l-.004-.061v-2.7h-2.7c-.248 0-.45-.201-.45-.45 0-.22.16-.404.37-.442l.08-.008h2.7v-2.7l.006-.08c.039-.21.222-.369.443-.369z"/>
</svg>`,
    mnmHeader: 'How to Style It',
    mnmCouponCode: 'with code',
};

export const MIX_AND_MATCH_StyliticsMarkup = `<style>#stylitics-widget-container .stylitics-arrow-btn {
    width: 38px;
    height: 38px;
    top: 50%;
    border: 1px solid black !important;
    background-color: white !important;
}

#stylitics-widget-container .stylitics-arrow-btn path {
    stroke: black !important;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-outer {
    flex-direction: row;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-outer .stylitics-sequence {
    justify-content: flex-start;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-outer .stylitics-card {
    margin-left: 4px;
    margin-right: 4px;
    justify-content: flex-start;
}

#stylitics-widget-container .stylitics-modal-header .stylitics-close {
    width: 20px;
    height: 20px;
    background: transparent;
}

#stylitics-widget-container .stylitics-item-inner-container {
    margin-left: 3px;
}

#stylitics-widget-container .stylitics-item-container .stylitics-item-info {
    justify-content: center;
    padding: 0;
}

#stylitics-widget-container .stylitics-item-container .stylitics-item-name-wrap {
    display: inline;
}

#stylitics-widget-container .stylitics-item-container .stylitics-item-price-and-cta.stylitics-item-price-and-cta-2-columns {
    align-items: flex-start;
}

#stylitics-widget-container .stylitics-item-container .stylitics-cta {
    position: relative;
    right: 36px;
}

#stylitics-widget-container .stylitics-item-container {
    padding: 30px 0;
}

#stylitics-widget-container .stylitics-item-container .stylitics-item-info {
    padding-left: 16px;
    font-size: 16px;
}

#stylitics-widget-container .stylitics-item-container .stylitics-swap-icon {
    background: transparent;
}

#stylitics-widget-container .stylitics-item-container .stylitics-swap-icon svg {
    opacity: 0;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-price {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-regular-price {
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-regular-price-slashed {
    text-decoration: line-through;
    color: #767676;
    font-weight: 400;
    display: none;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-sale-price {
    color: #e71324;
    font-size: 14px;
    font-weight: 600;
}
		
#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-price {	
	margin: 0;	
}

#stylitics-widget-container .stylitics-modal-header h1 {
    font-size: 16px;
    font-weight: bold;
    color: #202020;
}

#stylitics-widget-container .stylitics-items-list {
    padding: 0 20px 0;
}

#stylitics-widget-container .stylitics-container .stylitics-sequence {
    padding-left: 0px;
    justify-content: flex-start;
}

#stylitics-widget-container .stylitics-container .stylitics-card {	
	width: calc(100% + 48px) !important;
}	

#stylitics-widget-container .stylitics-moodboard-base svg {
    fill: none;
}

#stylitics-widget-container .stylitics-moodboard-base {
    font-family: 'Open Sans';
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-anchor-product-wrap {
    flex-basis: calc(100% / 6);
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-image {
    border: 1px solid #d8d8d8;
    max-height: unset !important;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-anchor-product-wrap .stylitics-item-name {
    font-size: 14px;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-price {
    font-size: 14px;
}
#stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-price .stylitics-ui-regular-price{
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
}
@media (pointer:none), (pointer:coarse) {
    
    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap {
        display: flex;
        align-self: flex-start;
        padding: 10px 46px 8px 16px;
        margin: 8px 0 4px;
        background-color: rgba(239 ,239 ,239);
        overflow: hidden;
        height: 100%;
        width: 100%;
        align-items: center;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-image{
        flex-basis: 20%;
        object-fit: contain;
        border: 1px solid #d8d8d8;
        min-width: unset !important;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap p {
        margin: 0;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-info {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding-left: 5%;
        justify-content: space-between;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-item-name {
        font-size: 16px;
        white-space: normal;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        line-height: 20px;
        max-height: 40px;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-moodboard-anchor-product-price {
        font-size: 14px;
        margin-top: 10px;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-item-regular-price {
        color: black;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-item-price-slashed {
        text-decoration: line-through;
        margin-left: 5px;
        color: gray;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap .stylitics-item-sale-price {
        color: black;
    }

    #stylitics-widget-container .stylitics-moodboard-base .stylitics-moodboard-anchor-product-wrap img {
        width: 140px;
        height: 140px;
    }
}


#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-swap-icon svg {
    opacity: 0;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item-info .stylitics-item-name {	
	font-size: 14px;	
    text-decoration: underline;
    -webkit-line-clamp: unset;
}	

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-product-grid {
    grid-row-gap: 5px; 
    grid-column-gap: 5px;
    background-color: transparent;
    border: none;
}

#stylitics-widget-container .stylitics-bundle-footer {
    visibility: hidden;
}

#stylitics-widget-container .stylitics-moodboard-item {
    background-color: white;
    grid-row: var(--grid-row-coords);
    grid-column: var(--grid-column-coords);
    outline: var(--grid-outline) solid white;
    outline-offset: -var(--grid-outline);
    position: relative;
    padding: var(--product-grid-item-padding);
    padding-bottom: 5px;
    outline: none;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-item {
    border: var(--grid-border-width-px) solid var(--grid-bgcolor);
}

#stylitics-widget-container .stylitics-container .stylitics-moodboard-item .stylitics-swap-icon {
    bottom: 0;
    left: 0;
    width: 36px;
    height: 36px;
}

#stylitics-widget-container .stylitics-container .stylitics-moodboard-item .stylitics-swap-icon svg {
    opacity: 0;
}

#stylitics-widget-container figcaption.stylitics-moodboard-bundle-header {
    font-weight: 600;
    padding: 0 0 15px var(--grid-outline);
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-item-image {
    border: solid 1px rgba(32, 32, 32, 0.2);
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus a {
    display: none;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-item-footer {
    color: #202020;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-item-name {
    overflow: visible;
    margin: 10px 0;
    padding-top: 0;
    height: 40px;
    -webkit-box-orient: unset;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-item-price {
    color: #E71324;
    font-size: 14px;
    font-weight: 600;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-swap-icon {
    bottom: 10px;
    left: 10px;
    width: 36px;
    height: 36px;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-focus .stylitics-swap-icon svg {
    opacity: 0;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-moodboard-swap-stage {
    border-left: 1px solid #e2e2e2;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-stage {
    padding-left: 10px;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-header {
    display: flex;
    font-size: 16px;
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-close-btn {
    padding: 0;
    transform: translate(-35px, 1px);
}

#stylitics-widget-container .stylitics-moodboard-widget-container .stylitics-mnm-title {
    margin: 0;
    padding: 5px 0;	
	font-size: 18px;	
	font-weight: 600;
}
.promotional-sale-price {
            color: #E71324 !important;
            font-family: "Arial" !important;
            font-size: 14px !important;
            font-weight: 700 !important;
        }
.promotional-text {
            font-style: italic !important;
            font-weight: 400 !important;
        }
/*# sourceMappingURL=moodboard.css.map */

</style>`;

export const MIX_AND_MATCH_StyliticsMarkupComposer = `<style>
div#stylitics-composer-container .stylitics-grid-layout{
  margin-bottom: 30px !important;
}


#stylitics-composer-container .t-red .stylitics-item-sale-price {
  color: red !important;
}
    #stylitics-composer-container .stylitics-grid-layout .stylitics-grid-item-info-name,
#stylitics-composer-container .stylitics-grid-layout p.stylitics-ui-price {
  padding: 0;
  text-align: center;
  height: auto !important;
  min-height: fit-content !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  line-height: 1.2 !important;
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-sale-price {
  color: rgb(231, 19, 36);
}

.stylitics-grid-item-non-editorial.stylitics-grid-item-static.stylitics-grid-item-anchor-item img.stylitics-ui-image {
      --max-size: 100% !important;
  
      max-height: 100% !important;
      max-width: 100% !important;
}

#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-regular-price-slashed {
  color: #000000;
}
#stylitics-composer-container .stylitics-grid-layout .stylitics-ui-carousel-card-list {
  --column-width: calc((100% - 0px) / 1.1) !important;
}

#stylitics-composer-container .stylitics-grid-layout li {
  height: auto !important;
  min-height: fit-content !important;
}

@media (max-width: 768px), (pointer: coarse) {
  div#stylitics-composer-container div.stylitics-grid-layout {
    height: auto !important;
    min-height: fit-content !important;
    max-height: none !important;
    overflow: visible !important;
    display: block !important;
  }
}

</style>`;
